import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [CommonModule, TranslateModule.forChild({ extend: true })],
    exports: [CommonModule, TranslateModule]
})
export class LanguageModule {
    static forRoot(): ModuleWithProviders<LanguageModule> {
        return {
            ngModule: LanguageModule
        };
    }
}
